var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 15.75C15.0759 15.75 16.0833 14.7426 16.0833 13.5C16.0833 12.2574 15.0759 11.25 13.8333 11.25C12.5906 11.25 11.5833 12.2574 11.5833 13.5C11.5833 14.7426 12.5906 15.75 13.8333 15.75Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83325 6.75C6.07589 6.75 7.08325 5.74264 7.08325 4.5C7.08325 3.25736 6.07589 2.25 4.83325 2.25C3.59061 2.25 2.58325 3.25736 2.58325 4.5C2.58325 5.74264 3.59061 6.75 4.83325 6.75Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 4.5H12.3333C12.7311 4.5 13.1126 4.65804 13.3939 4.93934C13.6752 5.22064 13.8333 5.60218 13.8333 6V11.25",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83325 6.75V15.75",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesIcon);
export default __webpack_public_path__ + "static/media/rules-icon.7fb6cd8cb5c615b7ee4f52b3bde8c06b.svg";
export { ForwardRef as ReactComponent };